/* eslint-disable */
import React, { forwardRef, ForwardedRef, MutableRefObject, useEffect, useRef } from 'react';
import {
	MOUSE,
	Vector2,
	Vector3,
	Vector4,
	Quaternion,
	Matrix4,
	Spherical,
	Box3,
	Sphere,
	Raycaster,
	MathUtils,
} from 'three';
import { ReactThreeFiber, extend, useFrame, useThree } from '@react-three/fiber';
import CameraControlsDefault from 'camera-controls';


const subsetOfTHREE = {
	MOUSE: MOUSE,
	Vector2: Vector2,
	Vector3: Vector3,
	Vector4: Vector4,
	Quaternion: Quaternion,
	Matrix4: Matrix4,
	Spherical: Spherical,
	Box3: Box3,
	Sphere: Sphere,
	Raycaster: Raycaster,
	MathUtils: {
		DEG2RAD: MathUtils.DEG2RAD,
		clamp: MathUtils.clamp,
	},
};

CameraControlsDefault.install({ THREE: subsetOfTHREE });
extend({ CameraControlsDefault });

export const CameraControls = forwardRef((_, ref) => {
	const cameraControls = useRef(null);
   
	const camera = useThree((state) => state.camera);
	const renderer = useThree((state) => state.gl);
	useFrame((_, delta) => { ref.current?.update(delta); });
	useEffect(() => { 
        if(ref.current){
            ref.current.enabled = _.enabled
			// ref.current.maxDistance = 29.154930119978143
			// ref.current.minDistance = 29.154930119978143

			ref.current.mouseButtons.wheel = CameraControlsDefault.ACTION.NONE

			window.controls = ref.current

			ref.current.toggleMouseWheel = function(){
				console.log("toggle")
				if(ref.current.mouseButtons.wheel == CameraControlsDefault.ACTION.NONE) {
					ref.current.mouseButtons.wheel = CameraControlsDefault.ACTION.DOLLY
				} else {
					ref.current.mouseButtons.wheel = CameraControlsDefault.ACTION.NONE
				}
			}
			
            if(_.position){
                ref.current.setPosition(_.position[0], _.position[1], _.position[2])
            }
            
            if(_.target){
                ref.current.setTarget(_.target[0], _.target[1], _.target[2])
            }

			if(_.focalOffset){
                ref.current.setFocalOffset(_.focalOffset[0], _.focalOffset[1], _.focalOffset[2])
            }
            
        }
       
    }, []);
	return (
		<cameraControlsDefault
			ref={ref}
			args={[camera, renderer.domElement]}
		/>
	);
});

// export type CameraControls = CameraControlsDefault;

function mergeRefs(refsx = []) {
    const refs = [refsx]
    console.log('refsx', refsx)
	return (instance) => {
		for (const ref of refs) {
			if (typeof ref === 'function') {
				ref(instance);
			} else if (ref) {
				ref.current = instance;
			}
		}
	};
}
